/* eslint-disable @atlassian/tangerine/import/no-relative-package-imports, @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/entry-points, @atlassian/tangerine/import/no-parent-imports */

import SuccessIcon from '@atlaskit/icon/core/migration/check-circle';
import CommentIcon from '@atlaskit/icon/core/migration/comment';
import DownloadIcon from '@atlaskit/icon/core/migration/download';
import FeedbackIcon from '@atlaskit/icon/core/migration/feedback';
import ErrorIcon from '@atlaskit/icon/core/migration/status-error--error';
import EditorInfoIcon from '@atlaskit/icon/core/migration/status-information--editor-info';
import InfoIcon from '@atlaskit/icon/core/migration/status-information--info';
import WarningIcon from '@atlaskit/icon/core/migration/status-warning--warning';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export type FlagMapping = Record<string, Flag>;

export type FlagMappingIcon =
	| typeof SuccessIcon
	| typeof ErrorIcon
	| typeof InfoIcon
	| typeof WarningIcon
	| typeof EditorInfoIcon
	| typeof CommentIcon
	| typeof DownloadIcon
	| typeof FeedbackIcon;

export type Flag = {
	component: FlagMappingIcon;
	label: string;
	color: string;
};

const flagMapping = {
	success: {
		component: SuccessIcon,
		label: 'success',
		color: token('color.icon.success', colors.G300),
	},
	error: {
		component: ErrorIcon,
		label: 'error',
		color: token('color.icon.danger', colors.R300),
	},
	info: {
		component: InfoIcon,
		label: 'info',
		color: token('color.icon.information', colors.T300),
	},
	warning: {
		component: WarningIcon,
		label: 'warning',
		color: token('color.icon.warning', colors.Y300),
	},
	smallInfo: {
		component: EditorInfoIcon,
		label: 'info',
		color: token('color.icon.discovery', colors.P300),
	},
	comment: {
		component: CommentIcon,
		label: 'comment',
		color: token('color.icon', colors.N300),
	},
	download: {
		component: DownloadIcon,
		label: 'download',
		color: token('color.icon', colors.N300),
	},
	feedback: {
		component: FeedbackIcon,
		label: 'comment',
		color: token('color.icon', colors.N300),
	},
};

export type FlagIcons = keyof typeof flagMapping;

export default flagMapping;
